/**
 * Geometry shared by the task list and the timeline.
 *
 * Both panes draw their own rows, so the numbers have to agree exactly or the
 * bars drift away from their labels. Keeping them in one file is what makes
 * that agreement checkable.
 */
export const ROW_HEIGHT = 30;
export const HEADER_HEIGHT = 40;
export const BAR_HEIGHT = 15;
export const DAY_WIDTH = 10;
export const TIMELINE_PADDING = 8;

export const MONTHS = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
];
